import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints }) => ({
  container: {
    padding: '2em 0'
  },
  headerTitle: {
    display: 'flex',
    marginBottom: '1em'
  },
  title: {
    fontWeight: 'bold',
    fontSize: '20px'
  },
  subtitle: {
    fontWeight: 'normal',
    fontSize: '14px'
  },
  offerContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'space-beteween'
  },
  discount: {
    fontWeight: 'bold'
  },
  buttonContainer: {
    alignSelf: 'center'
  },
  button: {
    minWidth: '100%'
  },
  divider: {
    width: 50,
    height: 5,
    backgroundColor: '#FA6724'
  },
  iconContainer: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  percentIcon: () => ({
    borderRadius: '50%',
    width: 56,
    height: 56,
    background: '#CCE2F1',
    color: '#000',
    textAlign: 'center',
    lineHeight: '55px',
    fontSize: '23px',
    fontWeight: 'bold',
    [breakpoints.down('md')]: {
      width: 46,
      height: 46,
      lineHeight: '45px'
    },
    [breakpoints.down('sm')]: {
      width: 38,
      height: 38,
      lineHeight: '37px'
    },
    [breakpoints.down('sm')]: {
      width: 46,
      height: 46,
      lineHeight: '45px'
    }
  })
}))
